/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

class WarrantySelectionRow {
  constructor(warrantyEl, collectionGroupKey) {
    if (!warrantyEl) {
      return;
    }

    this.el = warrantyEl;

    this.collectionGroupKey = collectionGroupKey;
    this.button = this.el.querySelector('button');

    this.onClick = this.handleOnClick.bind(this);
    this.button.addEventListener('click', this.onClick);

    this.onAddToCartError = this.handleAddToCartError.bind(this);
    document.body.addEventListener(
      `addToCartError_${this.el.dataset.warrantyId}`,
      this.onAddToCartError
    );

    this.onAddToCartSuccess = this.handleAddToCartSuccess.bind(this);
    document.body.addEventListener(
      `addToCartSuccess_${this.el.dataset.warrantyId}`,
      this.onAddToCartSuccess
    );
  }

  getUIElements() {
    return {
      // Errors sit on the <tr> below the warranty row (outside the context of `this`),
      // so we need to query from the document
      errorEl: document.querySelector(
        `[data-error-row="${this.el.dataset.warrantyId}"]`
      ),
    };
  }

  handleAddToCartError(e) {
    const error = e && e.detail && e.detail.message;

    const { errorEl } = this.getUIElements();

    if (errorEl && error) {
      errorEl.innerHTML = `<td class="product-form__error-cell" colspan="${
        window.sparkOptions ? 5 : 4
      }" data-warranty-error><span>${error}</span></td>`;
    }
  }

  handleClearAddToCartError() {
    const { errorEl } = this.getUIElements();

    if (errorEl) {
      errorEl.innerHTML = '';
    }
  }

  handleAddToCartSuccess(e) {
    [...document.querySelectorAll('button[name="add-warranty"]')].map(
      (button) => {
        button.innerHTML = 'Add';
        button.classList.remove('button--secondary');
      }
    );
  }

  handleOnClick(e) {
    e.preventDefault();

    const button = e.target;

    // Uncheck all other checkboxes first
    [...document.querySelectorAll('button[name="add-warranty"]')].map(
      (button) => {
        if (button.id !== e.target.id) {
          button.innerHTML = 'Add';
          button.classList.remove('button--secondary');

          window.WS.updateState(
            'REMOVE',
            {
              id: button.id,
              persist: false,
            },
            this.collectionGroupKey
          );
        }
      }
    );

    if (button.innerHTML === 'Add') {
      button.innerHTML = 'Remove';
      button.classList.add('button--secondary');

      window.WS.updateState(
        'UPDATE',
        {
          id: button.id,
          quantity: '1',
          price: this.el.dataset.warrantyPrice,
          persist: false,
        },
        this.collectionGroupKey
      );
    } else {
      button.innerHTML = 'Add';
      button.classList.remove('button--secondary');

      window.WS.updateState(
        'REMOVE',
        {
          id: button.id,
          persist: false,
        },
        this.collectionGroupKey
      );
    }

    const { errorEl } = this.getUIElements();

    if (errorEl.innerHTML !== '') {
      this.handleClearAddToCartError();
    }
  }
}

if (!customElements.get('warranty-selection')) {
  customElements.define(
    'warranty-selection',
    class WarrantySelection extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId;

        this.atcButton = this.querySelector('[data-atc-button]');
        this.warranties = this.querySelectorAll('[data-warranty-id]');

        if (this.atcButton) {
          this.atcButton.addEventListener(
            'click',
            this.addSelectionToCart.bind(this)
          );
        }

        [...this.warranties].forEach((warranty) => {
          new WarrantySelectionRow(warranty, `product_${this.productId}`);
        });
      }
    }
  );
}
